module.exports = __webpack_public_path__ + "static/media/47.43435a8f.jpg";